import { createSelector } from 'reselect';

export const authSelector = createSelector(
    state => state.auth,
    auth => auth
);

export const userSelector = createSelector(
    state => state.users,
    user => user
);

export const usersOnlineSelector = createSelector(
    state => state.usersOnline,
    user => user
);

export const newsSelector = createSelector(
    state => state.news,
    news => news
);

export const chapterSelector = createSelector(
    state => state.chapters,
    chapter => chapter
);

export const chapterMemberSelector = createSelector(
    state => state.chapterMembers,
    chapterMember => chapterMember
);

export const rankSelector = createSelector(
    state => state.ranks,
    rank => rank
);

export const feedSelector = createSelector(
    state => state.feed,
    feed => feed
);

export const awardSelector = createSelector(
    state => state.awards,
    award => award
);

export const awardCategorySelector = createSelector(
    state => state.awardCategories,
    category => category
);

export const awardRecipientSelector = createSelector(
    state => state.awardRecipients,
    awardRecipients => awardRecipients
);

export const recruitmentSelector = createSelector(
    state => state.recruitment,
    recruitment => recruitment
);

export const applicationSelector = createSelector(
    state => state.recruitment.applications,
    application => application
);

export const questionSelector = createSelector(
    state => state.recruitment.questions,
    question => question
);

export const interestSelector = createSelector(
    state => state.recruitment.interests,
    interest => interest
);

export const notificationSelector = createSelector(
    state => state.notifications,
    notification => notification
);

export const commentSelector = createSelector(
    state => state.comments,
    comment => comment
);

export const codexSelector = createSelector(
    state => state.codex,
    codex => codex
);

export const quoteSelector = createSelector(
    state => state.quotes,
    quote => quote
);

export const dkpSelector = createSelector(
    state => state.dkp,
    dkp => dkp
);

export const dkpStandingsSelector = createSelector(
    state => state.dkp.standings,
    standing => standing
);

export const eventSelector = createSelector(
    state => state.events,
    events => events
);

export const eventAttendanceSelector = createSelector(
    state => state.eventAttendance,
    attendee => attendee
);

export const itemSelector = createSelector(
    state => state.items,
    items => items
);

export const entitySelector = createSelector(
    state => state.entities,
    entities => entities
);

export const locationSelector = createSelector(
    state => state.locations,
    items => items
);

export const eventEntitySelector = createSelector(
    state => state.eventEntity,
    entities => entities
);

export const eventItemSelector = createSelector(
    state => state.eventItems,
    items => items
);

export const pollSelector = createSelector(
    state => state.polls,
    polls => polls
)

export const pollItemSelector = createSelector(
    state => state.pollItems,
    items => items
)

export const screenshotSelector = createSelector(
    state => state.screenshots,
    items => items
)

export const resourceSelector = createSelector(
    state => state.resources,
    resource => resource
)

export const resourceContributionSelector = createSelector(
    state => state.resourceContributions,
    contrib => contrib
)


// WEBPACK FOOTER //
// ./src/redux/selectors.js